







FUNCTIONS = require "scripts/common"
WP = require "scripts/wordpress"
module.exports =
	components:
		aboutPage: require "./about/pageTemplate"
		topPage: require "./top/pageTemplate"
		spinner: require "components/common/spinner"
	data: ->
		page: null
	computed:
		pageName: -> return this.$route.name
		projectName: -> return this.$route.params.projectName
		projectNo: -> return FUNCTIONS.getProjectNo this.projectName
		isLoading: ->
			for section in this.page.sections then if section.loading then return true
			for container in this.page.latests then if container.loading then return true
			return false
	methods:
		getPageObject: ->
			if this.pageName is "top" or this.pageName is "en_top" then return WP.getPageObject("top")
			return WP.getPageObject(this.projectName)
		getPosts: ->
			if this.isLoading then return
			for section in this.page.sections
				if section.content isnt null then continue
				endPoint = WP.getEndPoint(section.postType, section.id)
				WP.getContent(endPoint, section)
			for container in this.page.latests
				if container.content isnt null then continue
				endPoint = WP.getEndPoint(container.postType)
				fillter = ""
				if this.pageName is "about" or this.pageName is "en_about"
					# fillter = WP.getExcludeCategoriesFillter WP.getCategoryID(this.projectName)
					fillter = "projects=" + WP.getProjectID(this.projectName)
					fillter += "&"+WP.getCategoryFillter(container.categoryID)
					fillter += "&per_page=1"
				WP.getContent(endPoint, container, fillter)
	mounted: ->
		this.page = this.getPageObject()
		this.getPosts()
	updated: ->
		this.page = this.getPageObject()
		this.getPosts()



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/page/page.vue